export default "__VITE_ASSET__BU8VlIaM__"